import { Flex } from 'antd';

import {
  ATC_BEELINE,
  ATC_BEELINE_LABEL,
  EMAIL_HANDLER,
  EMAIL_LABEL,
  INSTAGRAM,
  INSTAGRAM_LABEL,
  TELEGRAM,
  TELEGRAM_LABEL,
  VK,
  VK_LABEL,
  WHATSAPP,
  WHATSAPP_LABEL,
  TELEGRAM_PERSONAL,
  TELEGRAM_PERSONAL_LABEL,
  MAX_MESSENGER,
  MAX_MESSENGER_LABEL,
  SMS_SERVICE,
  SMS_SERVICE_LABEL,
  TECH_SUPPORT,
  TECH_SUPPORT_LABEL,
} from '@app/constants';
import { SocialIntegrationIcon } from '@app/shared/ui/SocialIntegrationIcon';

const getIntegrationLabel = (
  integrationType: string,
  integrationLabel: string
) => {
  return (
    <Flex align="center" gap={8}>
      <SocialIntegrationIcon type={integrationType} size="md" />
      {integrationLabel}
    </Flex>
  );
};

export const SOCIAL_INTEGRATIONS_DICTIONARY = [
  {
    value: EMAIL_HANDLER,
    label: getIntegrationLabel(EMAIL_HANDLER, EMAIL_LABEL),
  },
  {
    value: WHATSAPP,
    label: getIntegrationLabel(WHATSAPP, WHATSAPP_LABEL),
  },
  {
    value: INSTAGRAM,
    label: getIntegrationLabel(INSTAGRAM, INSTAGRAM_LABEL),
  },
  {
    value: VK,
    label: getIntegrationLabel(VK, VK_LABEL),
  },
  {
    value: TELEGRAM,
    label: getIntegrationLabel(TELEGRAM, TELEGRAM_LABEL),
  },
  {
    value: ATC_BEELINE,
    label: getIntegrationLabel(ATC_BEELINE, ATC_BEELINE_LABEL),
  },
  {
    value: SMS_SERVICE,
    label: getIntegrationLabel(SMS_SERVICE, SMS_SERVICE_LABEL),
  },
  {
    value: TECH_SUPPORT,
    label: getIntegrationLabel(TECH_SUPPORT, TECH_SUPPORT_LABEL),
  },
];

// Подписи каналов строкой — для сводок, где иконка не нужна
export const SOCIAL_CHANNEL_TITLES: Record<string, string> = {
  [WHATSAPP]: WHATSAPP_LABEL,
  [INSTAGRAM]: INSTAGRAM_LABEL,
  [VK]: VK_LABEL,
  [TELEGRAM]: TELEGRAM_LABEL,
  [TELEGRAM_PERSONAL]: TELEGRAM_PERSONAL_LABEL,
  [MAX_MESSENGER]: MAX_MESSENGER_LABEL,
  [SMS_SERVICE]: SMS_SERVICE_LABEL,
};

export const SOCIAL_INTEGRATIONS_CHANNELS_FOR_COMMUNICATION = [
  {
    value: WHATSAPP,
    label: getIntegrationLabel(WHATSAPP, WHATSAPP_LABEL),
  },
  {
    value: INSTAGRAM,
    label: getIntegrationLabel(INSTAGRAM, INSTAGRAM_LABEL),
  },
  {
    value: VK,
    label: getIntegrationLabel(VK, VK_LABEL),
  },
  {
    value: TELEGRAM,
    label: getIntegrationLabel(TELEGRAM, TELEGRAM_LABEL),
  },
  {
    value: TELEGRAM_PERSONAL,
    label: getIntegrationLabel(TELEGRAM_PERSONAL, TELEGRAM_PERSONAL_LABEL),
  },
  {
    value: MAX_MESSENGER,
    label: getIntegrationLabel(MAX_MESSENGER, MAX_MESSENGER_LABEL),
  },
  {
    value: SMS_SERVICE,
    label: getIntegrationLabel(SMS_SERVICE, SMS_SERVICE_LABEL),
  },
];
